module.exports = __webpack_public_path__ + "asset/img/logo_default.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/logo_default.svg
// module id = 484
// module chunks = 8 10 15 17 19 33 37 38 42 43 44 46